import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-uncheck.png'

const UncheckedIcon = (props: any) => {
  return (
    <BaseIcon
      img={img}
      onClick={props.onClick}
      size={props.size}
      disabled={props.disabled}
    />
  )
}

export default UncheckedIcon
